export default function(_) {
  return _ === Object(_);
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isObject.js